module.exports = __webpack_public_path__ + "img/virtual_off.97e057e2.svg";